@if (isVisible()) {
<div class="app-download-banner">
  <p class="app-download-banner__text">{{ 'APP_DOWNLOAD_BANNER_TEXT' | localization }}</p>
  <div class="app-download-banner__stores">
    @for (store of stores; track store.url) {
    <a
      class="app-download-banner__store"
      [href]="store.url"
      target="_blank"
      rel="noopener noreferrer"
      [attr.aria-label]="store.title"
    >
      <img [src]="store.image" [alt]="store.title" width="155" height="45" />
    </a>
    }
  </div>
</div>
}
